import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const formatError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return JSON.stringify(detail);
};

// ---------------------------------------------------------------------------
// Global 401 interceptor — real-time session invalidation.
//
// When an Owner/Admin deletes a user (or revokes their session server-side),
// the backend cookie still exists in the browser but the user document no
// longer resolves, so `get_current_user` raises 401 "User not found".
//
// We catch every 401 on protected endpoints and dispatch a window event so
// the AuthContext can wipe local state, show a toast, and redirect to /login.
// Login / MFA / register endpoints themselves are excluded to avoid clobbering
// the natural "wrong password" UX on the login screen.
// ---------------------------------------------------------------------------
const AUTH_FREE_PATHS = [
  "/auth/login",
  "/auth/register",
  "/auth/mfa/verify",
  "/auth/forgot",
  "/auth/reset",
];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !AUTH_FREE_PATHS.some((p) => url.includes(p))) {
      // Fire-and-forget: AuthContext listens for this and handles the UX.
      try {
        window.dispatchEvent(
          new CustomEvent("auth:expired", {
            detail: { reason: error?.response?.data?.detail || "Session expired" },
          })
        );
      } catch {
        // SSR / non-browser context — nothing to do.
      }
    }
    return Promise.reject(error);
  }
);

export default api;
